// The product names people read, in one place (FPT-25). A trademark search on "Fowlguard Work" and
// "Fowlguard Apps" is pending, so every web app takes these from here rather than writing them out.
// Identifiers never follow a rename: hosts, routes, client ids, plan and app keys, database names and
// published file names (FowlguardProductivity-x64.exe) keep their names, as with Remote -> Bridge.
//
// Native code cannot import this file; the other copies are listed so a rename finds them all:
//   Windows/installer/fg-setup/src/consts.rs (work_name!), EnterpriseNotes/apps/shared/crates/ed-ui
//   and EnterpriseWorkbook/apps/shared/crates/es-ui (About), Shared/dotnet/Fg.Entitlements/ProductNames.cs.

/** The company's mark, small g. */
export const FOWLGUARD = "Fowlguard";

/** The paid suite: Mail, Drive, Notes, Workbook, Present, Reader and Meeting. */
export const WORK_NAME = "Fowlguard Work";

/** The suite's short name, where "Fowlguard" is already said ("Bridge + Work", "Work Standard"). */
export const WORK_SHORT = "Work";

/** The home and catalogue of every app Fowlguard makes for people, at apps.fowlguard.com. */
export const APPS_NAME = "Fowlguard Apps";

/** Fowlguard Work's own settings (plan, mail domains, mailboxes, lists, Meeting policy), at apps.fowlguard.com/admin. */
export const WORK_ADMIN_NAME = "Fowlguard Work Admin";
export const WORK_ADMIN_SHORT = "Work Admin";

/** People are managed in Fowlguard Identity (FS-597, FS-598), not in Work admin. */
export const IDENTITY_NAME = "Fowlguard Identity";
export const IDENTITY_URL = "https://identity.fowlguard.com/";

/** Products named by product, never folded into Work or Apps. */
export const SECURE_NAME = "Fowlguard Secure";
export const BRIDGE_NAME = "Fowlguard Bridge";
export const AUTHENTICATOR_NAME = "Fowlguard Authenticator";
export const RUSTSTUDIO_NAME = "Fowlguard Ruststudio";

/** Where Fowlguard Apps lives, and Work admin under it. */
export const APPS_URL = "https://apps.fowlguard.com";
export const WORK_ADMIN_URL = `${APPS_URL}/admin`;
